import axios from "axios";
import { showSessionExpiredAlert } from "../components/alerts";

// Función para obtener el tenant del subdominio
const getTenantId = () => {
  try {
    const hostname = window.location.hostname;

    // // Si estamos en localhost, usar un tenant por defecto para desarrollo
    // if (hostname === "localhost" || hostname === "127.0.0.1") {
    //   return "hospital-abc"; // Tenant por defecto para desarrollo
    // }

    // Extraer el subdominio
    const subdomain = hostname.split(".")[0];

    // Validar que el subdominio no sea 'www'
    if (subdomain && subdomain !== "www") {
      return subdomain;
    } else {
      // Si no hay subdominio válido, usar el hostname completo
      return hostname;
    }
  } catch (error) {
    console.error("Error getting tenant ID:", error);
    return "default";
  }
};

console.log("URL de la API:", process.env.REACT_APP_API_URL_BACK);
// Crear una instancia de Axios
const medicGeekApi = axios.create({
  // baseURL: "https://zaludapp.com/api", //process.env.REACT_APP_API_URL_BACK,
  baseURL: process.env.REACT_APP_API_URL_BACK,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para agregar automáticamente el header x-tenant-id y el token
medicGeekApi.interceptors.request.use(
  (config) => {
    // Verificar si el logout es intencional ANTES de agregar el token
    const isIntentionalLogout =
      localStorage.getItem("intentionalLogout") === "true";

    // Solo agregar el token si NO es logout intencional y hay token disponible
    if (!isIntentionalLogout) {
      const token =
        localStorage.getItem("token") || localStorage.getItem("accessToken");
      if (token && token.trim() !== "") {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // Agregar el tenant ID
    const tenantId = getTenantId();
    if (tenantId) {
      config.headers["x-tenant-id"] = tenantId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
medicGeekApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si hay un error de autenticación o token expirado
    if (error.response?.status === 401) {
      const errorData = error.response?.data;
      console.error("Error de autenticación:", errorData);

      // Verificar si el logout es intencional ANTES de cualquier otra lógica
      const isIntentionalLogout =
        localStorage.getItem("intentionalLogout") === "true";
      if (isIntentionalLogout) {
        console.log(
          "Logout intencional detectado, NO mostrando alerta de sesión expirada"
        );
        return Promise.reject(error);
      }

      // Verificar si hay token en localStorage ANTES de mostrar alerta
      const hasToken =
        localStorage.getItem("token") || localStorage.getItem("accessToken");
      if (!hasToken) {
        console.log(
          "No hay token en localStorage, NO mostrando alerta de sesión expirada"
        );
        return Promise.reject(error);
      }

      // Solo mostrar alerta si hay token y no es logout intencional
      if (!localStorage.getItem("sessionExpiredAlertShown")) {
        localStorage.setItem("sessionExpiredAlertShown", "true");

        // Verificar si es un JWT malformado
        if (
          errorData &&
          (errorData.message?.includes("malformed") ||
            errorData.error?.includes("malformed"))
        ) {
          console.error("JWT malformado detectado. Limpiando token...");
          // Limpiar tokens inválidos
          localStorage.removeItem("token");
          localStorage.removeItem("accessToken");

          // Mostrar alerta específica para JWT malformado
          showSessionExpiredAlert();
        } else {
          // Error 401 normal (token expirado)
          showSessionExpiredAlert();
        }
      }
    } else if (error.response?.status === 403) {
      console.error(
        "Error de autorización o tenant inválido:",
        error.response?.data
      );
    }
    return Promise.reject(error);
  }
);

export default medicGeekApi;
